export default __webpack_public_path__ + "static/media/memoriesText.9ac7745d.png";